<app-state-section [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
  <app-row *ngFor="let line of deliveryNoteLines; let i = index; last as isLast">
    <app-col cols="12" class="pb-6">
      <div class="brd brd-primary-light brd-solid bg-primary-lighter text-primary brd-1 px-3 py-2 flex align-center radius-2">
        <img [src]="'assets/images/clock.svg'" class="mr-2" />
        <span>
          {{ "shipments.LastJobUpdate" | translate }}:
          <b>{{ (shipment?.lastJobUpdate | date: 'medium') || "______"}}</b>
        </span>
      </div>
    </app-col>

    <app-col cols="6">
      <div class="info">
        <p class="info__title">{{ "shipments.ShortDescription" | translate }}</p>
        <p class="info__value">{{ line.shortDesc || '_____' }}</p>
      </div>
    </app-col>

    <app-col cols="6">
      <div class="info">
        <p class="info__title">{{ "shipments.UnitOfMeasure" | translate }}</p>
        <p class="info__value">{{ line.unitMeasurement || '_____' }}</p>
      </div>
    </app-col>

    <app-col cols="6">
      <div class="info">
        <p class="info__title">{{ "shipments.LoadingRemark" | translate }}</p>
        <p class="info__value">{{ line.loadingRemark || '_____' }}</p>
      </div>
    </app-col>

    <app-col cols="6">
      <div class="info">
        <p class="info__title">{{ "shipments.DeliveryLineID" | translate }}</p>
        <p class="info__value">{{ line.deliveryLineId || '_____' }}</p>
      </div>
    </app-col>

    <app-col cols="6">
      <div class="info">
        <p class="info__title">{{ "shipments.ProductID" | translate }}</p>
        <p class="info__value">{{ line.productId || '_____' }}</p>
      </div>
    </app-col>

    <app-col cols="6">
      <div class="info">
        <p class="info__title">{{ "shipments.Description" | translate }}</p>
        <p class="info__value">{{ line.desc || '_____' }}</p>
      </div>
    </app-col>

    <app-col cols="12">
      <div class="info">
        <p class="info__title">{{ "shipments.Status" | translate }}</p>
        <p class="info__value" [class.text-warn]="line.deletedFlag?.toLocaleLowerCase() === 'y'">
          {{ (line.deletedFlag?.toLocaleLowerCase() === 'y' ? 'shipments.Enum.ShipmentStatus.CANCELED' : 'shipments.Enum.Status.ACTIVE') | translate
          }}
        </p>
      </div>
    </app-col>

    <app-col cols="6">
      <div style="flex-wrap: nowrap" class="brd brd-400 p-2 radius-2">
        <app-row align="center">
          <app-col cols="auto">
            <ng-container>
              <img style="width: 40px" src="assets/images/check.svg" />
            </ng-container>
          </app-col>
          <app-col>
            <p class="weight-semibold mt-0">{{ line.orderAmount }}</p>
            <span class="text-600 h6">{{ "shipments.OrderedAmount" | translate }}</span>
          </app-col>
        </app-row>
      </div>
    </app-col>

    <app-col cols="6">
      <div style="flex-wrap: nowrap" class="brd brd-400 p-2 radius-2">
        <app-row align="center">
          <app-col cols="auto">
            <ng-container>
              <img style="width: 40px" src="assets/images/warning.svg" />
            </ng-container>
          </app-col>
          <app-col>
            <p class="weight-semibold mt-0">{{isSpecialProductType ? line.orderAmount : line.loadedAmount }}</p>
            <span class="text-600 h6">{{ "shipments.LoadedAmount" | translate }}</span>
          </app-col>
        </app-row>
      </div>
    </app-col>

    <mat-divider class="pos-static my-3" *ngIf="!isLast"></mat-divider>
  </app-row>
</app-state-section>
